var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["setIsHovered"] = "setIsHovered";
  ActionType2["setEffectiveImgSrc"] = "setEffectiveImgSrc";
  ActionType2["setEffectiveAltText"] = "setEffectiveAltText";
  return ActionType2;
})(ActionType || {});
export {
  ActionType
};
